import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Text from '../Text';
var boxSizes = {
  xs: {
    fontSize: 5,
    padding: 0.5,
    paddingHorizontal: 1
  },
  sm: {
    fontSize: 4,
    padding: 0.5,
    paddingHorizontal: 1.5
  },
  md: {
    fontSize: 4,
    padding: 1,
    paddingHorizontal: 2
  },
  lg: {
    fontSize: 3,
    padding: 1.5,
    lineHeight: 2,
    paddingHorizontal: 3
  }
};
export function Tab(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      href = _ref.href,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'backgroundSecondary' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      props = _objectWithoutPropertiesLoose(_ref, ["active", "disabled", "href", "color", "size"]);

  var tabProps = {
    as: active ? 'span' : href ? 'a' : 'button',
    fontWeight: 400,
    radiusTop: 4,
    cursor: active ? 'default' : 'pointer',
    transition: 'opacity 160ms ease-out',
    backgroundColor: color,
    disabled: disabled
  };

  if (!active) {
    if (disabled) {
      tabProps.opacity = 0.6;
      tabProps.cursor = 'not-allowed';

      if (href) {
        tabProps['aria-disabled'] = true;
      }
    } else {
      tabProps.href = href;
      tabProps.opacity = 0.8;
      tabProps.hover = {
        opacity: 1
      };
    }
  }

  return /*#__PURE__*/React.createElement(Text, _extends({}, tabProps, boxSizes[size], props));
}